import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { useEffect, useMemo, useState, useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { getUserInfo } from "../../redux/handlers/auth/getUserInfo.handler";
import { getAllMstDiscountType } from "../../redux/handlers/master/getAllMstDiscountType.handler";
import { getAllMstPaymentType } from "../../redux/handlers/master/getAllMstPaymentType.handler";
import { getAllMstPriceCategory } from "../../redux/handlers/master/getAllMstPriceCategory.handler";
import { getAllMstVat } from "../../redux/handlers/master/getAllMstVat.handler";
import { getAllWarehouse } from "../../redux/handlers/master/getAllWarehouse.handler";
import { getFirstMstCompany } from "../../redux/handlers/master/getFirstMstCompany.handler";
import { isValidArray, mapMstToOptions } from "utils/HelperFunction";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { getAllMstBranch } from "../../redux/handlers/master/getAllMstBranch.handler";
import { genNewReceiptDocNumber } from "../../redux/slices/logic/genNewReceiptDocNumber.slice";
import { useGlobalDocModalContext } from "contexts/GlobalDocModalContext";
import { mappingOptionNewItemReceiptCol } from "utils/HelperReceiptFunction";
import { getAllMstNewItemReceiptCol } from "../../redux/slices/master/getAllMstNewItemReceiptCol.slice";
export var useInitReceipt = function(param) {
    var receiptID = param.receiptID, formdata = param.formdata, setFormdata = param.setFormdata;
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalDocModalContext = useGlobalDocModalContext(), modalNotiDocAlert = _useGlobalDocModalContext.modalNotiDocAlert, setModalNotiDocAlert = _useGlobalDocModalContext.setModalNotiDocAlert;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isLoading = _useGlobalLoaderContext.isLoading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    // Reducers
    var reducers = {
        paymentType: useAppSelector(function(state) {
            return state.getAllMstPaymentTypeReducer;
        }),
        priceCategory: useAppSelector(function(state) {
            return state.getAllMstPriceCategoryReducer;
        }),
        discountType: useAppSelector(function(state) {
            return state.getAllMstDiscountTypeReducer;
        }),
        vat: useAppSelector(function(state) {
            return state.getAllMstVatReducer;
        }),
        warehouse: useAppSelector(function(state) {
            return state.getAllWarehouseReducer;
        }),
        userInfo: useAppSelector(function(state) {
            return state.getUserInfoReducer;
        }),
        company: useAppSelector(function(state) {
            return state.getFirstMstCompanyReducer;
        }),
        genNewReceiptNumber: useAppSelector(function(state) {
            return state.genNewReceiptDocNumberReducer;
        }),
        receiptItemCol: useAppSelector(function(state) {
            return state.getAllMstNewItemReceiptColReducer;
        }),
        branch: useAppSelector(function(state) {
            return state.getAllMstBranchReducer;
        })
    };
    // Local state
    var _useState = _sliced_to_array(useState(null), 2), userInfo = _useState[0], setUserInfo = _useState[1];
    var _useState1 = _sliced_to_array(useState(null), 2), companyInfo = _useState1[0], setCompanyInfo = _useState1[1];
    // Derived options using useMemo for performance
    var options = useMemo(function() {
        var _reducers_paymentType_data, _reducers_priceCategory_data, _reducers_discountType_data, _reducers_vat_data, _reducers_warehouse_data, _reducers_receiptItemCol_data, _reducers_branch_data, _reducers_paymentType_data1, _reducers_priceCategory_data1, _reducers_discountType_data1, _reducers_vat_data_data, _reducers_vat_data1, _reducers_warehouse_data1, _reducers_receiptItemCol_data1, _reducers_branch_data1;
        var optionsInit = {
            paymentType: [],
            priceCategory: [],
            discountType: [],
            vat: [],
            warehouse: [],
            receiptItemCol: [],
            branch: []
        };
        var isReady = isValidArray((_reducers_paymentType_data = reducers.paymentType.data) === null || _reducers_paymentType_data === void 0 ? void 0 : _reducers_paymentType_data.data) && isValidArray((_reducers_priceCategory_data = reducers.priceCategory.data) === null || _reducers_priceCategory_data === void 0 ? void 0 : _reducers_priceCategory_data.data) && isValidArray((_reducers_discountType_data = reducers.discountType.data) === null || _reducers_discountType_data === void 0 ? void 0 : _reducers_discountType_data.data) && isValidArray((_reducers_vat_data = reducers.vat.data) === null || _reducers_vat_data === void 0 ? void 0 : _reducers_vat_data.data) && isValidArray((_reducers_warehouse_data = reducers.warehouse.data) === null || _reducers_warehouse_data === void 0 ? void 0 : _reducers_warehouse_data.data) && isValidArray((_reducers_receiptItemCol_data = reducers.receiptItemCol.data) === null || _reducers_receiptItemCol_data === void 0 ? void 0 : _reducers_receiptItemCol_data.data) && isValidArray((_reducers_branch_data = reducers.branch.data) === null || _reducers_branch_data === void 0 ? void 0 : _reducers_branch_data.data);
        if (!isReady) return optionsInit;
        return {
            paymentType: mapMstToOptions(((_reducers_paymentType_data1 = reducers.paymentType.data) === null || _reducers_paymentType_data1 === void 0 ? void 0 : _reducers_paymentType_data1.data) || []),
            priceCategory: mapMstToOptions(((_reducers_priceCategory_data1 = reducers.priceCategory.data) === null || _reducers_priceCategory_data1 === void 0 ? void 0 : _reducers_priceCategory_data1.data) || []),
            discountType: mapMstToOptions(((_reducers_discountType_data1 = reducers.discountType.data) === null || _reducers_discountType_data1 === void 0 ? void 0 : _reducers_discountType_data1.data) || []),
            vat: (_reducers_vat_data1 = reducers.vat.data) === null || _reducers_vat_data1 === void 0 ? void 0 : (_reducers_vat_data_data = _reducers_vat_data1.data) === null || _reducers_vat_data_data === void 0 ? void 0 : _reducers_vat_data_data.map(function(item) {
                return {
                    label: item.name,
                    value: item.id,
                    vat: item.value
                };
            }),
            warehouse: mapMstToOptions(((_reducers_warehouse_data1 = reducers.warehouse.data) === null || _reducers_warehouse_data1 === void 0 ? void 0 : _reducers_warehouse_data1.data) || []),
            receiptItemCol: mappingOptionNewItemReceiptCol(((_reducers_receiptItemCol_data1 = reducers.receiptItemCol.data) === null || _reducers_receiptItemCol_data1 === void 0 ? void 0 : _reducers_receiptItemCol_data1.data) || []),
            branch: mapMstToOptions(((_reducers_branch_data1 = reducers.branch.data) === null || _reducers_branch_data1 === void 0 ? void 0 : _reducers_branch_data1.data) || [])
        };
    }, [
        reducers.paymentType.data,
        reducers.priceCategory.data,
        reducers.discountType.data,
        reducers.vat.data,
        reducers.warehouse.data,
        reducers.receiptItemCol.data,
        reducers.branch.data
    ]);
    var isInitReceiptLoading = useMemo(function() {
        return reducers.paymentType.isFetching || reducers.priceCategory.isFetching || reducers.discountType.isFetching || reducers.vat.isFetching || reducers.userInfo.isFetching || reducers.company.isFetching || reducers.genNewReceiptNumber.isFetching || reducers.receiptItemCol.isFetching || reducers.warehouse.isFetching || reducers.branch.isFetching;
    }, [
        reducers.paymentType.isFetching,
        reducers.priceCategory.isFetching,
        reducers.discountType.isFetching,
        reducers.vat.isFetching,
        reducers.userInfo.isFetching,
        reducers.company.isFetching,
        reducers.genNewReceiptNumber.isFetching,
        reducers.receiptItemCol.isFetching,
        reducers.warehouse.isFetching,
        reducers.branch.isFetching
    ]);
    // Load master data
    var loadMstData = useCallback(function() {
        dispatch(getAllMstPaymentType());
        dispatch(getAllMstPriceCategory());
        dispatch(getAllMstDiscountType());
        dispatch(getAllMstVat());
        dispatch(getAllWarehouse());
        dispatch(getFirstMstCompany());
        dispatch(getAllMstNewItemReceiptCol());
        dispatch(getAllMstBranch());
    }, []);
    // Load resources
    var loadResources = useCallback(function() {
        dispatch(getUserInfo({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        if (!receiptID) {
            dispatch(genNewReceiptDocNumber({
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    }, [
        receiptID
    ]);
    // Handle incoming data
    useEffect(function() {
        if (reducers.userInfo.data && reducers.userInfo.data !== userInfo) {
            setUserInfo(reducers.userInfo.data.data);
        }
        if (reducers.company.data && reducers.company.data !== companyInfo) {
            setCompanyInfo(reducers.company.data.data);
        }
        if (reducers.genNewReceiptNumber.data && !receiptID && reducers.genNewReceiptNumber.data.data !== formdata.doc_number) {
            setFormdata(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    doc_number: reducers.genNewReceiptNumber.data.data
                });
            });
            setModalNotiDocAlert(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    extra: {
                        genDocNumber: reducers.genNewReceiptNumber.data.data,
                        createdDocNumber: prev.extra.createdDocNumber
                    }
                });
            });
        }
    }, [
        reducers.userInfo.data,
        reducers.company.data,
        reducers.genNewReceiptNumber.data,
        userInfo,
        companyInfo,
        formdata.doc_number,
        receiptID
    ]);
    // Auto-load
    useEffect(function() {
        loadMstData();
        loadResources();
    }, [
        loadMstData,
        loadResources
    ]);
    // useEffect(() => {
    //   setIsLoading(isInitReceiptLoading);
    // }, [isInitReceiptLoading]);
    return {
        isInitReceiptLoading: isInitReceiptLoading,
        options: options,
        userInfo: userInfo,
        companyInfo: companyInfo
    };
};
